var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploadimg"},[_c('el-upload',{attrs:{"action":_vm.$store.getters.requestBaseUrl + _vm.upbase,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload,"data":_vm.upData}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }